import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import Masthead from "@/components/Masthead";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/Marquee";
import Intro from "@/components/Intro";
import TacoIndex from "@/components/TacoIndex";
import MapSection from "@/components/MapSection";
import Findings from "@/components/Findings";
import Standard from "@/components/Standard";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-paper text-ink min-h-screen">
      <div className="noise-overlay" aria-hidden="true" />
      <Masthead />
      <main>
        <Hero />
        <EditorialMarquee />
        <Intro />
        <TacoIndex />
        <MapSection />
        <EditorialMarquee reverse />
        <Findings />
        <Standard />
      </main>
    </div>
  );
}

export default App;
